import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import Paragraph from '../../Paragraph/Paragraph';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${pxToRem(16)};
`;

const BodyTitle = styled.h3`
  font-size: ${pxToRem(16)};
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  text-align: center;
`;

const PhoneLink = styled.a`
  color: ${themeColors.colorPrimary};
  text-decoration: underline;
`;

const NonUSAccountRestrictionModal = ({ isOpen, close }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      close={close}
      hideHeader
      verticalCenter
      isCenterModal
    >
      <ModalBody style={{ padding: '20px 40px' }}>
        <IconWrapper>
          <InfoIcon width={48} height={48} />
        </IconWrapper>
        <BodyTitle>{t('portfolio.sellFromHome.nonUs.title')}</BodyTitle>
        <Paragraph centerText>
          <PhoneLink
            href={`tel:${t('portfolio.sellFromHome.nonUs.phoneNumber')}`}
          >
            {t('portfolio.sellFromHome.nonUs.needHelp')}{' '}
            {t('portfolio.sellFromHome.nonUs.phone')}
          </PhoneLink>
        </Paragraph>
        <ModalButtons
          isVertical
          textTransform="none"
          marginTop
          showOnlyPrimary
          primaryButtonProps={{
            label: t('common.close'),
            onClick: close,
          }}
        />
      </ModalBody>
    </Modal>
  );
};

NonUSAccountRestrictionModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default NonUSAccountRestrictionModal;
